import { render } from "./prompts-table-row-data.vue?vue&type=template&id=efff3cc4&lang=pug"
import script from "./prompts-table-row-data.vue?vue&type=script&lang=js"
export * from "./prompts-table-row-data.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__